import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import CustomPostHogProvider from '@/components/custom-post-hog-provider'

import './index.css'
import { routeTree } from './routeTree.gen'

// Add default title constant
const DEFAULT_TITLE = 'Zenify'

// Add title update function
const updateDocumentTitle = (unreadCount = 0) => {
  if (unreadCount === 0) {
    document.title = DEFAULT_TITLE
    return
  }
  const displayCount = unreadCount > 9 ? '9+' : unreadCount
  document.title = `${DEFAULT_TITLE} (${displayCount})`
}

import notificationStore from '@/store/notification-store'
notificationStore.subscribe((state) => {
  updateDocumentTitle(state.unreadCount)
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { queryClient },
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <CustomPostHogProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </CustomPostHogProvider>
  </StrictMode>,
)
